import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import React, { ReactNode } from 'react'
import './EditableText.scss'

export function EditableText({
  value,
  onChange,
  onDelete,
  className,
  children,
  placeholder = 'Title',
  buttonPlaceholder = 'Enter text'
}: {
  value: string
  onChange?: (value: string) => void
  onDelete?: () => void
  className?: string
  children?: ReactNode
  placeholder?: string
  buttonPlaceholder?: ReactNode
}) {
  const [editing, setEditing] = React.useState(false)

  const [text, setText] = React.useState(value)
  const textRef = React.useRef(text)
  textRef.current = text
  React.useEffect(() => {
    if (value !== textRef.current) {
      setText(value)
    }
  }, [value])

  const updateText = React.useCallback(
    (newValue: string) => {
      setText(newValue)
      onChange?.(newValue)
    },
    [onChange]
  )

  return (
    <div
      className={classNames('poe-editable-text', className, {
        'poe-editing': editing
      })}>
      {!!onChange && !editing && (
        <div className="poe-buttons">
          <FontAwesomeIcon
            icon={faEdit}
            onClick={() => {
              setEditing(!editing)
            }}
          />
          {!!onDelete && (
            <FontAwesomeIcon icon={faTrashAlt} onClick={onDelete} />
          )}
        </div>
      )}

      <div className="poe-editable-text-content">
        {editing ? (
          <>
            <input
              type="text"
              value={text || ''}
              placeholder={placeholder}
              onChange={(event) => {
                updateText(event.target.value)
              }}
            />
            <button onClick={() => setEditing(false)}>Close</button>
          </>
        ) : (
          <>
            {text ? (
              children ? (
                children
              ) : (
                text
              )
            ) : (
              <div className="poe-empty">{buttonPlaceholder}</div>
            )}
          </>
        )}
      </div>
    </div>
  )
}
